import {mixed, string, StringSchema} from 'yup';
import {CONTEXT_SEND_PARAMETER} from '../constants';

export const idString = () =>
   mixed().when(CONTEXT_SEND_PARAMETER, {
      is: true,
      then: mixed().transform(function (val, origin) {
         if (!val) return null;
         return val;
      }),
      otherwise: string().ensure(),
   }) as StringSchema;
